import React from 'react';
import { withRouter } from 'react-router-dom';
import Content from '@/modules/common/components/Content';
import GridItem from '@/modules/common/components/GridItem';
import ContentBody from '@/modules/common/components/ContentBody';
import ContentHeader from '@/modules/common/components/ContentHeader';
import GridContainer from '@/modules/common/components/GridContainer';
import Settings from './Settings/Settings';
import Information from './Information/Information';
import '../../styles/Offer.scss';

const Offer = (props) => {
    const name = props.match.params.name;
    const breadcrumbs = [
        {name: 'Офферы', to: '/offers/'},
        {name: name}
    ];
    return (
        <Content id="offer">
            <ContentHeader breadcrumbs={breadcrumbs}/>
            <ContentBody>
                <GridContainer>
                    <GridItem xs={12} md={6} xl={4}>
                        <Information/>
                    </GridItem>
                    <GridItem xs={12} md={6} xl={4}>
                        <Settings/>
                    </GridItem>
                </GridContainer>
            </ContentBody>
        </Content>
    );
};

let Component = Offer;
Component = withRouter(Component);

export default Component;
